const currencyOptions = {
	style: "currency",
	currency: "EUR",
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
};

function formatPercent(number: string | number): string {
	const formattedNumber = (Number(number) * 0.01).toLocaleString("de-DE", {
		style: "percent",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
	return formattedNumber;
}

function formatCurrency(number: string | number): string {
	const formattedNumber = Number(number).toLocaleString(
		"de-DE",
		currencyOptions,
	);
	return formattedNumber;
}

export { currencyOptions, formatCurrency, formatPercent };
